import React, { lazy, Suspense } from "react";

const PositionMatrixModal = lazy(
  () => import("app/components/PositionMatrixModal/PositionMatrixModal")
);

type Props = {
  isPositionMatrixModalOpen: boolean;
  closePositionMatrixModal: (...args: Array<any>) => any;
  positionMatrixModalEvent: (...args: Array<any>) => any;
};

const PositionMatrix: React.FC<Props> = ({
  isPositionMatrixModalOpen,
  closePositionMatrixModal,
  positionMatrixModalEvent,
}) => {
  return (
    <Suspense fallback={<div className="fallback">loading...</div>}>
      <PositionMatrixModal
        modalOpen={isPositionMatrixModalOpen}
        closeModal={closePositionMatrixModal}
        event={positionMatrixModalEvent}
      />
    </Suspense>
  );
};

export default PositionMatrix;
